module.exports = __webpack_public_path__ + "static/media/title_16.2caf34ae.svg";